import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['content', 'button']
    static classes = [ "open", "close"]
    connect() {
        if(!this.hasOpenClass) {
            this.openClassList = "bg-chevron-down";
        }
        else{
            this.openClassList = this.openClass;
        }
        if(!this.hasCloseClass) {
            this.closeClassList = "bg-chevron-up";
        }
        else{
            this.closeClassList = this.closeClass;
        }

    }
    toggle(e){
        e.preventDefault();
        this.contentTarget.classList.toggle('hidden')
        if(this.contentTarget.classList.contains('hidden'))
        {
            this.buttonTarget.classList.replace(this.closeClassList, this.openClassList);
        }
        else{
            this.buttonTarget.classList.replace(this.openClassList,  this.closeClassList);
        }
    }
}
